import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Button } from './components/ui/button';

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-white" data-testid="privacy-policy-page">
      <header className="sticky top-0 z-50 w-full border-b bg-white shadow-sm">
        <div className="container flex h-16 items-center">
          <a href="/">
            <Button variant="ghost" className="gap-2 text-royal-maroon" data-testid="back-home-btn">
              <ArrowLeft className="h-4 w-4" /> Back to Home
            </Button>
          </a>
        </div>
      </header>

      <main className="container max-w-3xl py-12 px-4">
        <h1 className="text-3xl font-serif font-bold text-gray-900 mb-8">Privacy Policy</h1>
        <p className="text-sm text-gray-500 mb-8">Last updated: March 30, 2026</p>

        <div className="prose prose-gray max-w-none space-y-6 text-gray-700 leading-relaxed">
          <section>
            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-3">1. Introduction</h2>
            <p>Royal Life Steel Furniture Pvt Ltd ("we", "our", or "us") is committed to protecting your personal information and your right to privacy. This Privacy Policy explains how we collect, use, and safeguard your information when you visit our website www.royalsteelfurniture.in.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-3">2. Information We Collect</h2>
            <p>We collect information that you voluntarily provide to us when you:</p>
            <ul className="list-disc pl-6 space-y-2 mt-2">
              <li>Fill out the enquiry/contact form (name, phone number, message)</li>
              <li>Contact us via phone or WhatsApp</li>
              <li>Browse our website (usage data via cookies and analytics)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-3">3. How We Use Your Information</h2>
            <p>We use the information we collect to:</p>
            <ul className="list-disc pl-6 space-y-2 mt-2">
              <li>Respond to your enquiries and provide product information</li>
              <li>Process and manage orders and dealer applications</li>
              <li>Send you relevant updates about our products (only if requested)</li>
              <li>Improve our website and services</li>
              <li>Comply with legal obligations</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-3">4. Information Sharing</h2>
            <p>We do not sell, trade, or rent your personal information to third parties. We may share your information only with:</p>
            <ul className="list-disc pl-6 space-y-2 mt-2">
              <li>Service providers who assist us in operating our website (hosting, analytics)</li>
              <li>Legal authorities if required by law</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-3">5. Cookies and Analytics</h2>
            <p>Our website uses Google Analytics and Google Tag Manager to understand how visitors interact with our site. These services may use cookies to collect anonymous usage data. You can control cookie preferences through your browser settings.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-3">6. Data Security</h2>
            <p>We implement appropriate technical and organizational security measures to protect your personal information, including SSL encryption, secure servers, and access controls. However, no method of transmission over the Internet is 100% secure.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-3">7. Your Rights</h2>
            <p>You have the right to:</p>
            <ul className="list-disc pl-6 space-y-2 mt-2">
              <li>Request access to the personal data we hold about you</li>
              <li>Request correction or deletion of your personal data</li>
              <li>Opt out of marketing communications</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-3">8. Contact Us</h2>
            <p>If you have questions about this Privacy Policy, please contact us at:</p>
            <p className="mt-2">
              <strong>Royal Life Steel Furniture Pvt Ltd</strong><br />
              Near S.T. Workshop, Dalda Factory Square,<br />
              New Cotton Market Rd, Ghat Road,<br />
              Nagpur, Maharashtra 440018<br />
              Phone: +91 9373102545<br />
              GST: 27AADCR9622B1ZI
            </p>
          </section>
        </div>
      </main>
    </div>
  );
}
